import { Dispatch } from '@reduxjs/toolkit';
import axiosInstance, { ApiKeys, getApiUrl } from 'src/utils/ApiHelper';
import { STORE_KEYS } from '../constants';
import { setRepaymentHistory } from '../reducers/caseDetailSlice';

export const getRepaymentHistory =
  (
    loanaccountnumber: string,
    customerreferenceid: string,
    payload: {
      page: number;
      size: number;
    }
  ) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.FETCH_REPAYMENT_HISTORY, { loanId: loanaccountnumber });
    axiosInstance
      .get(url, {
        headers: {
          loanaccountnumber,
          customerreferenceid
        },
        params: payload
      })
      .then(res => {
        dispatch(
          setRepaymentHistory({
            lan: loanaccountnumber,
            customerRefrenceId: customerreferenceid,
            key: STORE_KEYS.REPAYMENTS_HISTORY,
            data: res.data
          })
        );
      });
  };
